import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function Attendance() {
  const [stats, setStats] = useState(null);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/attendance/stats").then(r => setStats(r.data));
    api.get("/attendance?limit=200").then(r => setLogs(r.data));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-extrabold text-slate-900">Frequência</h1>
        <p className="text-slate-500">Análise de acessos e permanência</p>
      </div>

      <Card className="p-5 border border-slate-200">
        <h3 className="font-heading font-bold text-slate-900 mb-4">Picos por horário</h3>
        <div className="h-64" data-testid="attendance-peak-hours-heatmap">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={stats?.hourly || []}>
              <XAxis dataKey="hour" tick={{ fontSize: 10 }}/>
              <YAxis tick={{ fontSize: 11 }}/>
              <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }}/>
              <Bar dataKey="count" fill="#09090B" radius={[6,6,0,0]}/>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <Card className="p-5 border border-slate-200">
        <h3 className="font-heading font-bold text-slate-900 mb-4">Histórico completo</h3>
        <div className="max-h-[500px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
              <tr>
                <th className="text-left py-2">Aluno</th>
                <th className="text-left py-2">Data/Hora</th>
                <th className="text-left py-2">Confiança</th>
                <th className="text-left py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id} className="border-b border-slate-100">
                  <td className="py-2 text-slate-900">{l.student_name}</td>
                  <td className="py-2 text-slate-600">{new Date(l.timestamp).toLocaleString("pt-BR")}</td>
                  <td className="py-2 font-mono text-xs">{(l.confidence * 100).toFixed(0)}%</td>
                  <td className="py-2">
                    <span className={`text-xs px-2 py-0.5 rounded-full ${l.granted ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>
                      {l.granted ? "Liberado" : "Negado"}
                    </span>
                  </td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={4} className="text-center text-slate-500 py-8">Sem registros</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
